import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import StarsIcon from '../../assets/stars.svg';
import BaseLauncher from '../BaseLauncher';
import LauncherButton from '../LauncherButton';

interface Props {
    className?: string;
}

const UnauthorizedView: React.FC<Props> = ({ className }) => {
    const location = useLocation();

    return (
        <BaseLauncher
            title={
                <>
                    {'Get Started with'}
                    &nbsp;
                    <strong>{'AI Insights:'}</strong>
                    &nbsp;
                    {'Log in or Create an Account'}
                </>
            }
            description={'Leverage the power of AI to quickly understand vulnerabilities, impacts, and exploitability'}
            action={
                <LauncherButton
                    component={Link}
                    startIcon={<StarsIcon />}
                    to={{
                        pathname: '/login',
                        state: { from: location.pathname + location.search }
                    }}
                >
                    {'Try AI Insights'}
                </LauncherButton>
            }
            className={className}
        />
    );
};

export default UnauthorizedView;
